import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHamm() {
  return (
    <CityPageTemplate
      city="Hamm"
      slug="hamm"
      intro="Hamm als Verkehrsknotenpunkt im Ruhrgebiet – wir bringen Deine Finanzen auf Kurs."
      description="Unabhängige & digitale Finanzberatung für Hamm: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
